import { createApp } from "vue";
import MapMovement from '@/pages/MapMovement.vue';
import MapLandmark from '@/pages/MapLandmark.vue';
import MapLocus from '@/pages/MapLocus.vue';

function attachVueApp(App) {
    const app = createApp(App, {
        url: $('#map').data('action'),
    });
    app.provide('permissions', $('#map').data('permissions'));
    app.provide('map_api_url', $('#map').data('map_api_url'));
    app.provide('conditions', $('#map').data('conditions'));
    return app.mount('#map');
}

/**
 * 動態管理ページ用のスクリプト
 */
if (is_route('movement.index')) {
    const params = _request.get_parameters(location.search, true);
    const mode = params['mode'] ?? '';
    switch (mode) {
        case 'address_search':
            $.fn.mapLandmark = attachVueApp(MapLandmark);
            break;
        case 'movement_locus':
            $.fn.mapLocus = attachVueApp(MapLocus);
            break;
        default:
            $.fn.mapMovement = attachVueApp(MapMovement);
            break;
    }

    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        movement_event_set();
    });
}

/**
* ページ読み込み時のイベント設定
*/
window.movement_event_set = function () {

    /*---- init ----*/

    // 動態表示で設定したイベントをクリアしておく
    //clearMovementMapEvent($('#zmap_main'));

    /*---- MAP mode切替 ----*/

    // $(document).on('click', '[data-name="mode"]:not(.active)', function () {
    //     let params = new URLSearchParams(window.location.search);
    //     params.set('mode', $(this).data('value'));
    //     window.location.search = params.toString();
    // });

    /*---- 車両選択画面 ----*/

    // 画面表示
    // $(document).on('click', '[data-select_vehicle-modal]', function () {
    //     _modal.create(this, 'select_vehicle-modal', [], true, function(){
    //         initialize('tree-multiselect');
    //     });
    // });
    // 設定保存
    $(document).on('click', '[data-select_vehicle-save-modal]', function () {
        _modal.submit(this, 'select_vehicle-save-modal', function(){
            window.location.reload();
        }, null, '-form', true);
    });

    /*---- メッセージ登録画面 ----*/

    // // 画面表示
    // $(document).on('click', '[data-message-modal]', function () {
    //     _modal.create(this, 'message-modal', [], true, function(){
    //         initialize('tree-multiselect');
    //     });
    // });
    // 設定保存
    $(document).on('click', '[data-message-save-modal]', function () {
        _modal.submit(this, 'message-save-modal', null, null, '-form', true);
    });

    /*---- 動態設定画面 ----*/

    // 画面表示
    $(document).on('click', '[data-movement_config-modal]', function () {
        _modal.create(this, 'movement_config-modal', ['section_id'], true);
    });
    // 設定保存
    $(document).on('click', '[data-config-save-modal]', function () {
        _modal.submit(this, 'config-save-modal', function(){
            window.location.reload();
        }, null, '-form', true);
    });

    /*---- 各画面イベント設定 ----*/

    let params = _request.get_parameters(location.search, true);
    let mode = params['mode'] ?? '';
    switch (mode) {
        case 'address_search':
            address_search_event_set();
            break;
        case 'movement_locus':
            movement_locus_event_set();
            break;
        default:
            movement_map_event_set();
    }
}
